import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { BillyticsPublicContainerComponent } from '../billytics-public-container-component/billytics-public-container-component';

@Component({
  selector: 'app-privacy-policy-component',
  imports: [MatCardModule, BillyticsPublicContainerComponent],
  templateUrl: './privacy-policy-component.html',
  styleUrl: './privacy-policy-component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrivacyPolicyComponent {}
